/**
 * Route for `geo-breakdown-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GeoBreakdownWidgetPage } from "../features/geo-breakdown-widget/GeoBreakdownWidgetPage";

export const geoBreakdownWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/geo-breakdown-widget",
	component: GeoBreakdownWidgetPage,
});

export default geoBreakdownWidgetRoute;
